/**
 * Frontend Error-Reporting an das Backend
 *
 * Sendet Fehlermeldungen an POST /api/errors.
 * Rate-Limited im Backend (50/15min), zusätzlich Client-seitig
 * um Netzwerk-Spam bei Fehler-Kaskaden zu vermeiden.
 */

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

const MAX_REPORTS_PER_MINUTE = 5;
const WINDOW_MS = 60_000;

// Fixed-Window (tumbling) — Zaehler reset wenn WINDOW_MS seit windowStart
// verstrichen sind. Kein Timer, kein HMR-Leak. Edge: an der Fenster-
// Grenze sind theoretisch 2*MAX_REPORTS moeglich (letzter Burst vor
// Reset + erster Burst danach); fuer Error-Reporting akzeptabel.
let windowStart = Date.now();
let reportsInWindow = 0;

export function reportError(error: Error, context?: string): void {
  const now = Date.now();
  if (now - windowStart >= WINDOW_MS) {
    windowStart = now;
    reportsInWindow = 0;
  }
  if (reportsInWindow >= MAX_REPORTS_PER_MINUTE) return;
  reportsInWindow++;

  const payload = {
    message: error.message,
    stack: error.stack,
    context,
    userAgent: navigator.userAgent,
    url: window.location.href,
  };

  // Fire-and-forget — Fehler beim Reporting sollen die App nicht beeinflussen
  fetch(`${API_URL}/api/errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {
    // Stille Fehler — Backend möglicherweise nicht erreichbar
  });
}
